/**
 * Action types that can be applied to the entity.
 */
export enum ActionType {
  /**
   * Can update entity fields.
   */
  Edit = 'Edit',
  /**
   * Can change status to approved.
   */
  Approve = 'Approve',
  /**
   * Can delete or schedule entity deletion.
   */
  Delete = 'Delete',
  /**
   * Can change status to pending.
   */
  SetPending = 'SetPending',
  /**
   * Can change status to complete.
   */
  Complete = 'Complete',
  /**
   * Can change status to canceled.
   */
  Cancel = 'Cancel',
  /**
   * Can change status to rejected.
   */
  Reject = 'Reject',
  /**
   * Can change status to updating.
   */
  SetUpdating = 'SetUpdating',
  /**
   * Can accept terms of use.
   */
  AcceptTou = 'AcceptTou',
  /**
   * Can create upload.
   */
  CreateUpload = 'CreateUpload',
  /**
   * Can create collection.
   */
  CreateCollection = 'CreateCollection',
  /**
   * Can create request.
   */
  CreateRequest = 'CreateRequest',
  /**
   * Can copy or clone a virtual machine request.
   */
  Copy = 'Copy',
  /**
   * Can change status to submitted.
   */
  Submit = 'Submit'
}

/**
 * Entity model with allowed actions.
 */
export class EntityAction<TEntity> {
  /**
   * Allowed actions list.
   */
  actions: ActionType[];
  /**
   * The entity (payload).
   */
  value: TEntity;
}
